import { render, staticRenderFns } from "./EcommerceLivesTable.vue?vue&type=template&id=04b98ce6&scoped=true&"
import script from "./EcommerceLivesTable.vue?vue&type=script&lang=js&"
export * from "./EcommerceLivesTable.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceLivesTable.vue?vue&type=style&index=0&id=04b98ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b98ce6",
  null
  
)

export default component.exports